import { Injectable } from '@angular/core';
import {BaseServiceService} from "../base-service.service";
import {lastValueFrom, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoExpressaService extends BaseServiceService {
  private authenticatedToken?: string;

  private checkAutenticacaoExpressaFatura(faturaTokenVisualizacaoExpressa: string): Observable<string>{
    return this.get("client_area/authenticate_token_invoice/"  + faturaTokenVisualizacaoExpressa);
  }

  public isTokenAuthenticated(token: string): boolean {
    return this.authenticatedToken === token && !!localStorage.getItem('x-session-token-ac');
  }

  async autenticarToken(token: string): Promise<any> {
    if(!token){ // Não executar se estiver vazio
      return;
    }

    if (this.isTokenAuthenticated(token)) {
      return;
    }

    try{
      this.showSpinner();
      const resToken = await lastValueFrom(this.checkAutenticacaoExpressaFatura(token));
      localStorage.setItem('x-session-token-ac', resToken);
      this.authenticatedToken = token;
    } catch (error) {
      console.error(error);
    } finally {
      this.hideSpinner();
    }
  }
}
